import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Form } from "react-bootstrap";

import { getAvailableRoles } from "../../../../redux/accountManagementReducer/actionsAccountManagement";

import styles from "./roles.module.css";

const Roles = ({ getData, type, onSave, handleCloseClick, initialData }) => {
  const dispatch = useDispatch();

  const rolesData = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.allRoles;
  });

  const availableRoles = useSelector((state) => {
    const { accountManagementReducer } = state;
    return accountManagementReducer.availableRoles;
  });

  const [roles, setRoles] = useState(rolesData);

  const handleOnChange = (role, checked) => {
    const updatedRole = { ...role, isRole: checked };
    updateRole(updatedRole);
  };

  const updateRole = (updatedRole) => {
    const newRoles = roles.map((role) => {
      if (role.id === updatedRole.id) {
        return updatedRole;
      } else {
        return role;
      }
    });

    getData(newRoles);
    setRoles(newRoles);
  };

  const handleCloseSave = (event) => {
    onSave(roles, event);
  };

  useEffect(() => {
    if (Object.keys(initialData).length > 0) {
      setRoles((prevRoles) => {
        const hasIsRole = initialData.some((item) =>
          item.hasOwnProperty("isRole"),
        );

        if (!hasIsRole) {
          const updatedRoles = prevRoles.map((role) => ({ ...role }));

          initialData.forEach((dataObj) => {
            const matchingRole = updatedRoles.find(
              (role) => role.roleid === dataObj.roleid,
            );
            matchingRole.isRole = false;

            if (matchingRole) {
              matchingRole.isRole = true;
            }
          });
          return updatedRoles;
        } else {
          return initialData;
        }
      });
    }
  }, [initialData]);

  useEffect(() => {
    const roleIds = roles
      .filter((item) => item.isRole === true)
      .map((item) => item.id)
      .join(",");

    dispatch(getAvailableRoles(roleIds));
  }, [roles]);

  return (
    <Form>
      <Form.Group className={styles["roles"]}>
        {roles.map((role) => (
          <div className={styles["checkbox-container"]} key={role.id}>
            <input
              disabled={
                availableRoles.length > 0 &&
                !availableRoles.includes(role.roleid)
              }
              type="checkbox"
              id={role.id}
              checked={role.isRole}
              onChange={(e) => handleOnChange(role, e.target.checked)}
              className={styles["checkbox"]}
            />
            <Form.Label className={styles["role-name"]}>
              {role.label}
            </Form.Label>
          </div>
        ))}
      </Form.Group>
      <Form.Group className={styles["actions-buttons-block"]}>
        <button
          className={styles["save-btn"]}
          onClick={(event) => handleCloseSave(event)}
        >
          Сохранить
        </button>
        <button className={styles["close-btn"]} onClick={handleCloseClick}>
          Закрыть
        </button>
      </Form.Group>
    </Form>
  );
};

export default Roles;
